"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const constants_1 = require("../../constants");
const LoadingSpinner_1 = require("../../shared/LoadingSpinner");
const AuthenticationActions_1 = require("../../authentication/AuthenticationActions");
const mapStatToProps = state => {
    return { user: state.authentication.user, organization: state.authentication.organization };
};
const mapDispatchToProps = dispatch => {
    return {
        logout: () => {
            dispatch(AuthenticationActions_1.logoutUser());
        }
    };
};
class LogOutTempComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            state: constants_1.ProgressState.Loading
        };
    }
    render() {
        this.props.logout();
        return React.createElement("div", { className: "full-center-cont" }, React.createElement(LoadingSpinner_1.default, null));
    }
}
const LogOutTemp = react_redux_1.connect(mapStatToProps, mapDispatchToProps)(LogOutTempComponent);
exports.default = LogOutTemp;


//////////////////
// WEBPACK FOOTER
// ./client/src/landing/components/LogOutTemp.tsx
// module id = 1353
// module chunks = 0 1